var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "key_vacancies position-relative" },
    [
      _c(
        "v-tabs",
        {
          attrs: {
            "next-icon": "mdi-arrow-right-bold-box-outline",
            "prev-icon": "mdi-arrow-left-bold-box-outline",
            "show-arrows": "",
          },
          on: { change: _vm.changeTab },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tabs-slider"),
          _vm._v(" "),
          _vm._l(_vm.items, function (item) {
            return _c("v-tab", { key: item.label }, [
              _c("span", { staticClass: "key_vacancies__tab" }, [
                _vm._v("\n      " + _vm._s(item.label) + "\n    "),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.items, function (tabItem) {
          return _c(
            "v-tab-item",
            { key: tabItem.label },
            [
              _c("v-card", { attrs: { flat: "" } }, [
                _c(
                  "div",
                  { staticClass: "key_vacancies__grid" },
                  _vm._l(tabItem.item, function (el) {
                    return _c(
                      "div",
                      {
                        key: el.label + el.address,
                        staticClass:
                          "key_vacancies__item position-relative d-flex flex-column",
                      },
                      [
                        _c("a", {
                          staticClass:
                            "position-absolute w-100 h-100 t-0 l-0 zi-1",
                          attrs: { href: el.url },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex-grow-1" }, [
                          _vm._v(_vm._s(el.label)),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(el.address))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center  key_vacancies__item_info",
                          },
                          [
                            el.experience
                              ? _c("div", { staticClass: "mr-4" }, [
                                  _c("strong", [_vm._v("Опыт:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(el.experience) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            el.employment
                              ? _c("div", [
                                  _c("strong", [_vm._v("Занятость:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(el.employment) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }